import AuthDecoration from "./images/auth-decoration.png";

// Per-tenant logo, injected at build time. Falls back to the default mark when unset.
export const brandLogoUrl = import.meta.env.VITE_LOGO_URL || AuthDecoration;

// Per-tenant system name, injected at build time.
export const brandSystemName = import.meta.env.VITE_SYSTEM_NAME || "szkoleń";

// Per-tenant public client app (student site) URL, injected at build time. Used for widget embed codes
// and the sign-up form link. Required for production builds (vite.config.js); empty only in local dev,
// where links come out relative instead of pointing at another client's site. No trailing slash.
export const clientAppUrl = (import.meta.env.VITE_CLIENT_APP_URL || "").replace(/\/+$/, "");
